const Trips = {
  tripPath: (id: string) => `/api/GipsyyWeb/Agency/Rails/Trips/${id}`,
  tripPathOriginal: (id: string) => `/Agency/Rails/Trips/${id}`,
  tripsPath: () => '/api/trips',
  tripsPathDelete: (id: string) => `/api/trips/${id}`,
  tripsPathNew: () => '/Agency/Rails/Trips',
  ticketsPath: () => '/api/tickets',
  stationsPath: () => '/api/stations',
};

export default Trips;
